module.exports = __webpack_public_path__ + "img/item4.7b026bb7.png";